import css from './CheckoutProcess.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import withTranslation from 'components/HOC/WithTranslation'
import Loader from 'components/Layout/Loader'
import { useHandleGSFastCheckout } from 'components/Pages/CheckoutProcess/hooks/useHandleGSFastCheckout'
import { useHandleProcessComplete } from 'components/Pages/CheckoutProcess/hooks/useHandleProcessComplete'
import { useHandleProcessError } from 'components/Pages/CheckoutProcess/hooks/useHandleProcessError'
import { useStartProcess } from 'components/Pages/CheckoutProcess/hooks/useStartProcess'

const CheckoutProcess: React.FC = () => {
  useStartProcess()
  useHandleProcessComplete()
  useHandleGSFastCheckout()
  useHandleProcessError()

  const { t } = useTranslation()

  return (
    <Loader>
      <div className={css.container}>
        <div>{t('checkout:process_payment_verify')}</div>
      </div>
    </Loader>
  )
}

const namespaces = ['checkout']
export default withTranslation(namespaces)(CheckoutProcess)
